import { HTMLProps } from 'react'

export enum GetModelActions {
  selection = 'selection',
  subscribe = 'subscribe',
  preview = 'preview'
}
export interface GetModelProps {
  defaultKey: string
  onChange?: (event: any) => void
  optionsConfig?: { [index in GetModelActions] : { show?: boolean, selected?: boolean }}
  buttonLabel?: string
  inputProps?: HTMLProps<HTMLInputElement>
  showHelpText?: boolean
  useIcon?: boolean
  fullWidth?: boolean
}
